export default "__VITE_ASSET__OeW04RIG__"